<template>
    <el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
        <a type="button" @click="filterStatus(filter_status)"  style="cursor:pointer;" >
            <el-card shadow="always" class="processando" :class="[{ 'card-active': is_active.includes(filter_status)}, status_class]" body-style="padding:20px">
                <div class="text text_status">{{ status_text }}</div>
                <div class="text ammount">{{ ammount }}</div>
            </el-card>
        </a>
    </el-col>
</template>

<script>
    export default {
        name: "Quadro",
        props: ['status_text', 'ammount', 'status_class', 'filter_status', 'is_active'],
        methods: {
            filterStatus(status) {
                this.$emit('handleValue', status);
            },
        }
    }
</script>  
<style scoped>
    .ativo{
        color: #000000;
    }
    .inativo{
        color: #B00020;
    }
    .text_status{
        font-size:35px;
    }
    .ammount{
        font-size:70px;
    }
    .card-active{
        background-color: #8D8D8D;
    }
    .el-card .is-always-shadow{
        min-height: auto !important;
        height: 150px;
        margin: 5px;
    }
    .el-card .el-card__body .text{
        text-align: center !important;
        font-weight: bolder;
    }
    .el-card .el-card__body{
        height: -webkit-fill-available !important;
    }
</style>